<template>
  <tr class="pricing-table__row">
    <td class="pricing-table__cell pricing-table__cell--xl">{{ subComponentName }} <!-- <button class="btn btn-xsm btn-tertiary" @click.prevent="populateComponent"><i class="fa fa-refresh"></i></button> --></td>
    <td class="pricing-table__cell align-cntr">{{ formatCurrencyValue(best, 4) }}</td>
    <td class="pricing-table__cell align-cntr">{{ formatCurrencyValue(high, 4) }}</td>
    <td class="pricing-table__cell align-cntr">{{ formatCurrencyValue(low, 4) }}</td>
  </tr>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { formatCurrency } from '../../../../common/helpers'

export default {
  props: ['subComponentName', 'subComponentId', 'requestId', 'term', 'termUsage', 'date', 'modalVisible'],
  data() {
    return {
      selectedDate: '',
      fullData: [],
    }
  },
  computed: {
    pricingRequestStatus() {
      return this.$store.getters.pricingRequestStatus
    },
    contextualData() {
      if (this.fullData.length && this.date) {
        return this.fullData.filter(item => moment(item.date).format('M/DD/YYYY') === this.date)[0]
      }
    },
    best() {
      if (this.contextualData && this.contextualData.avg) {
        return (this.contextualData.avg  / this.termUsage) + (this.contextualData.broker_fee * 1)
      } 
    },
    high() {
      if (this.contextualData && this.contextualData.high) {
        return (this.contextualData.high / this.termUsage) + (this.contextualData.broker_fee * 1)
      }
    },
    low() {
      if (this.contextualData && this.contextualData.low) {
        return (this.contextualData.low / this.termUsage) + (this.contextualData.broker_fee * 1)
      }
    },
  },
  methods: {
    populateComponent() {
      if (this.requestId && this.subComponentId) {
        let term = this.term

        axios.get('/pricing-calculator/data/requests/' + this.requestId + '/components/' + this.subComponentId)
          .then((response) => {
            this.fullData = response.data[term]
          })
      }
    },
    formatCurrencyValue(val, decimals) {
      return formatCurrency(val, decimals)
    }
  },
  watch: {
    modalVisible(bool){
      if (bool) {
        this.populateComponent()
      }
    },
    pricingRequestStatus(val) {
      setTimeout(() => {
        this.populateComponent()
      }, 500)
    }
  }
}
</script>
